import { gettext } from '@eventbrite/legacy-infra.i18n';
import React from 'react';
import styles from './FeedbackDisplay.module.scss';

export const FeedbackDisplay = (props: { helpCenterLanguage: string }) => {
    const { helpCenterLanguage } = props;
    const contactOrganizerUrl = `/help/${helpCenterLanguage}/articles/647151/how-to-contact-the-event-organizer/`;

    return (
        <p className={styles.feedbackText} data-testid="reason_feedback-radio">
            {gettext(
                'Questions about the online event link, event location, or event details? Have feedback about the event? Learn how to contact the event organizer',
            )}{' '}
            <a
                href={contactOrganizerUrl}
                rel="noopener noreferrer"
                target="_blank"
                title={gettext('Link to contacting the organizer').toString()}
                aria-label={gettext(
                    'Link to contacting the organizer',
                ).toString()}
            >
                {gettext('here')}
            </a>
            .
        </p>
    );
};
